export default class MoveBackgroundsToCategoryRequest {
	BackgroundFileIds: Array<string> = null;
	CategoryId?: number = null;
	constructor(obj?: Partial<MoveBackgroundsToCategoryRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
